import React from 'react';
import { Image } from '../image/Image';
import { CoreListItem } from '../types/data';
import { TCoreOptions } from '../types/options';
import { getFontStyles } from '../utils/styles';
import styles from './list.module.css';

type CoreListTrailingElProps = {
    item: CoreListItem;
    palette: TCoreOptions;
};

const CoreListTrailingEl = ({ item, palette }: CoreListTrailingElProps) => {
    if (item.trailingSupportingText) {
        return (
            <span className={styles.trailingText} style={{ ...getFontStyles(palette), color: palette.onSurfaceVariant }}>
                {item.trailingSupportingText}
            </span>
        );
    }

    if (item.trailingIcon) {
        return <Image src={item.trailingIcon} width={24} height={24} iconColor={palette.onMain} />;
    }

    return null;
};

export { CoreListTrailingEl };
